var agreements = agreements || {};
agreements.admin = agreements.admin || {};

agreements.admin = {
	initAgreementForm: function () {
		var $validFrom = $('#validFrom');
		var $validTo = $('#validTo');

		if ($validFrom.val().length > 0) {
			var minDate = new Date($validFrom.datepicker('getDate'));
			minDate.setDate(minDate.getDate() + 1);
			$validTo.datepicker('option', 'minDate', minDate);
		}

		$validFrom.bind('change', function() {
			var minDate = new Date($(this).datepicker('getDate'));
			minDate.setDate(minDate.getDate() + 1);
			$validTo.datepicker('option', 'minDate', minDate);
		});
	},

	initAgreementSuppliersForm: function() {
		agreements.admin.initMultiChecker();

		var $select = $('.select select', '#agreementSupplier');
		agreements.admin.validateSelect($select);
		$select.change(function() {
			agreements.admin.validateSelect('#agreementSupplier .select select');

			var $id = $(this).attr('id');
			if ($id.indexOf('agreement') > 0) {
				agreements.admin.updateCategories($id, $(this).val());
			}
		});
	},

	initMultiChecker: function() {
		$('.multiChecker').each(function() {
			var $this = $(this);
			$('a.label', $this).on('click', function(e) {
				e.preventDefault();
				$(this).parent().toggleClass('open');
				var $siblings = $(this).closest('tr').siblings();
				$('.multiChecker.open', $siblings).removeClass('open');
			});
			agreements.admin.bindCheckboxes($this);
		}).on('click', function(e) {
			e.stopPropagation();
		});
		$('body').on('click', function() {
			$('.multiChecker').removeClass('open');
		});

		$(document).keyup(function(e) {
			if (e.keyCode === 27) {
				$('.multiChecker.open').removeClass('open');
			}
		});

		$('input:checkbox', '.multiChecker').on('keypress', function(e){
			if((e.keyCode ? e.keyCode : e.which) === 13) {
				e.preventDefault();
				$(this).trigger('click');
			}
		});
	},

	bindCheckboxes: function($multiChecker) {
		$multiChecker.find('input[type="checkbox"]').on('click', agreements.admin.checkboxClick);
	},

	checkboxClick: function() {
		var $this = $(this);
		var $multiChecker = $this.closest('.multiChecker');
		var $counter = $multiChecker.find('.label span');
		var count = $multiChecker.find('input:checked').length;
		$counter.text(count);
	},

	validateSelect: function(select) {
		var selectedOptions = [];
		$(select).each(function() {
			if (this.value > 0) {
				selectedOptions.push(this.value);
			}
		});

		$('option', select).each(function() {
			if (!$(this).is(':selected') && $.inArray($(this).val(), selectedOptions) !== -1) {
				$(this).attr('disabled', 'disabled');
			}
			else {
				$(this).removeAttr('disabled');
			}
		});
	},

	updateCategories: function(selectElement, agreementId) {
		var index = selectElement.replace(/[^\d.]/g, '');
		var $multiChecker = $('#' + selectElement).closest('tr').find('.multiChecker');
		$('.label span', $multiChecker).text('0');
		var $wrap = $multiChecker.find('.lmnt');
		if ($wrap.length < 1) {
			$wrap = $('<div/>');
			$wrap.addClass('lmnt');
			$multiChecker.append($wrap);
		}
		$wrap.empty();

		if (index >= 0) {
			var base = 'data-' + index + '-subcategories';
			var name = base + '[]';
			$.ajax({
				type: 'GET',
				'url': '/_/moya/agreements/agreement/categories/' + agreementId,
				'dataType': 'json',
				success: function (r) {
					Object.keys(r).forEach(function(i) {
						var label = r[i];
						var $el = $('<label/>');
						var id = base + '-' + i;
						$el.attr('for', id);
						var $input = $('<input/>');
						$input.attr({
							'id': id,
							'type': 'checkbox',
							'name': name,
							'value': i
						});
						$el.append($input);
						$el.append(label);
						$wrap.append($el);
					});
					agreements.admin.bindCheckboxes($multiChecker);
				}
			});
		}
	},

	initContactEdit: function() {
		var activeElement = document.getElementById('active');
		var sendElement = document.getElementById('elm_sendEmail');
		sendElement.querySelector('#sendEmail').classList.remove('hide');
		var initial = activeElement.checked;
		if (!initial) {
			var func = function(el) {
				if (el.checked) {
					sendElement.classList.remove('hide');
				}
				else {
					sendElement.classList.add('hide');
				}
			};
			activeElement.addEventListener('change', function (event) {
				func(event.target);
			});
			func(activeElement);
		}
	}

};
